import React, { useRef, useEffect } from "react";

/**
 * Hook that alerts clicks outside of the passed ref
 */

interface Props {
  callback: () => void;
  children: React.ReactNode;
  width?: number | string;
}

function useOutsideWrapper(
  ref: React.MutableRefObject<any>,
  callback: () => void
) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: Event) {
      if (ref.current && !ref.current.contains(event.target)) {
        if (callback) callback();
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, callback]);
}

/**
 * Component that alerts if you click outside of it
 */
function OutsideClickWrapper({ callback, children, width }: Props) {
  const wrapperRef = useRef(null);
  useOutsideWrapper(wrapperRef, callback);

  return (
    <div style={{ width }} className="outside-click-wrapper" ref={wrapperRef}>
      {children}
    </div>
  );
}

export default OutsideClickWrapper;
